













































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    existItemInList
} from '../../core/utils';
import ListWithItems from '../../core/components/ListWithItems.vue';
import Button from '../../core/components/Button.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import  DatePickerRange from '../../core/components/DatePickerRange.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';

@Component({
    components: {
        DatePickerRange,
        Button
    }
})
export default class FilterByDateRange extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    
    @Prop({default: false}) visible: boolean;
    modalTitle: string = 'Filtrar por rango de fecha'
    dateRangeSelected: any = [];

    @Emit()
    closeModal(item) {}

    @Emit()
    clearFilterByDateRange(){
        this.updateRangeDate([]);
        return []
    }
    
    @Emit()
    updateFilterDateRange(){
        let datePicker = this.$refs.datepickrange as HTMLFormElement;
        let startDate = datePicker.getStartDate;
        let endDate = datePicker.getEndDate;
        this.updateRangeDate([startDate, endDate])
        return [startDate, endDate]
    }

    updateRangeDate(value) {
       this.dateRangeSelected = [];
       this.dateRangeSelected = value;
     }


   

    //methods
    mounted() {
        
    }
}
